const state = {
  title: '',
  items: [],
  total: 0
}

const getters = {
  getTitle: state => state.title,
  getItems: state => state.items,
  getOffset: state => state.items.length,
  getTotal: state => state.total
}

const mutations = {
  UPDATE_TITLE: (state, string) => {
    state.title = string
  },
  UPDATE_ITEMS: (state, items) => {
    state.items = [ ...items ]
  },
  UPDATE_TOTAL: (state, number) => {
    state.total = number || 0
  },
  ADD_ITEMS: (state, array) => {
    state.items = [...state.items, ...array]
  }
}

const actions = {
  updateTitle: ({ commit }, title) => {
    commit('UPDATE_TITLE', title)
  },
  updateItems: ({ commit }, items) => {
    commit('UPDATE_ITEMS', items)
  },
  updateTotal: ({ commit }, total) => {
    commit('UPDATE_TOTAL', total)
  },
  addItems: ({ commit, dispatch }, pages) => {
    commit('ADD_ITEMS', pages.items)
    dispatch('updateTotal', pages.total)
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
